class DrawerLocations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      if(event.target.classList.contains('drawer__variant-button')) this.onVariantButtonClick(event);
    })
  }

  onVariantButtonClick(event) {
    this.querySelectorAll(".active").forEach(el => el.classList.remove("active"))
    event.target.classList.add("active")
    this.querySelector(`.${event.target.dataset.target}`)?.classList.add("active")
  }
}
customElements.define('drawer-locations', DrawerLocations);
